import paginationFactory from "react-bootstrap-table2-paginator";
import { PageOptions } from "../pages/components/PageParams";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { CustomTextFilter, getCellStyle, GetHeaderStyle } from "./Helper";
import { FormatEditBox } from "./Helper2";

//** Multirow table reuseable */
export const CreateTableSelectionMultiRow = (props) => {
  const { selectRowParams, keyFieldName, columns, data } = props;

  return (
    <BootstrapTable
      bootstrap4
      keyField={keyFieldName}
      rowClasses={"boostrap-table-row"}
      data={data ?? []}
      columns={columns ?? []}
      striped
      hover
      condensed
      headerWrapperClasses="headerWrapper"
      wrapperClasses="table-wrapper"
      bordered={true}
      pagination={paginationFactory(PageOptions)}
      //pagination={paginationFactory(PageOptions)}
      filter={filterFactory()}
      selectRow={SelectedRowAction(selectRowParams)}
      // rowEvents={rowEvents}
      // cellEdit={cellEditFactory({
      //   mode: "click",
      //   blurToSave: true,
      //   autoSelectText: true,
      // })}

      //ref={ref}
    />
  );
};

export const SelectedRowAction = (props) => {
  const { onSelect, onSelectAll } = props;

  return {
    mode: props?.mode ?? "radio",

    clickToSelect: true,
    // classes: "row-h-over-selected",
    hideSelectColumn: props?.hideSelectColumn ?? false,
    // style: (row, rowIndex) => {
    //   // const backgroundColor = rowIndex > 1 ? "#00BFFF" : "#00FFFF";
    //   const backgroundColor = rowIndex>1?""
    //   return { backgroundColor };
    // },
    headerColumnStyle: {
      background: "var(--thirth-color)",
      padding: "5px 0px 0px 8px",
    },
    selectColumnStyle: {
      width: "20px",
    },
    onSelectAll: onSelectAll,
    onSelect: onSelect,
  };
};

/**
 * Build columns from input object
 * @param {*} clazz
 * @returns
 */
export const BuildsColumns = (clazz) => {
  let cols = [];

  for (const key in clazz) {
    let o = clazz[key];
    if (o?.isListOnTable) {
      cols.push({
        dataField: o.tableColumnFieldName ?? o.fieldName,
        text: o.caption,
        sort: o?.sort ?? true,
        headerStyle: o?.defaultHeaderStyle ?? GetHeaderStyle("auto"),
        style: o?.defaultCellStyle ?? getCellStyle(),
        hidden: o?.isHiddenColumn,
        filter: o?.filter ?? textFilter(CustomTextFilter),
        formatter: o?.formatter,
      });
    }
  }
  return cols;
};

export const BuildsColumnsWithEdit = (clazz, OnEditClick, OnDeleteClick) => {
  let cols = BuildsColumns(clazz);
  cols.push({
    dataField: "Edit",
    text: "",
    sort: false,
    headerStyle: GetHeaderStyle("110px"),
    formatter: (x, row) => FormatEditBox(x, row, OnEditClick, OnDeleteClick),
    style: getCellStyle(),
  });
  return cols;
};
